import { create } from "zustand";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const useAuthStore = create((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email_id: email,
        password: password,
      });

      const { status, message, access_token, data } = response.data;

      if (!status) {
        return { success: false, message: message || "Login failed." };
      }

      set({
        user: data,
        token: access_token,
        isAuthenticated: true,
      });

      return { success: true, message };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.detail ||
          error.response?.data?.message ||
          "Invalid email or password",
      };
    }
  },

  logout: () => {
    set({
      user: null,
      token: null,
      isAuthenticated: false,
    });
  },
}));
